export enum AdapterEnum {
    DOCSERVICE = 'DocServiceAdapter',
    JRADAPTER = 'JRAdapter',
    T360 = 'T360Adapter',
}
